export const DISPLAY_DATE_FORMAT = 'dd-MM-yyyy';
export const FORM_DATE_FORMAT = 'yyyy-MM-dd';

export const KSEF_START_DATE = new Date(2025, 10, 1).getTime();
